import { useEffect } from "react";
import { detectPlatform } from "../../platform.js";
import { useSettingsStore } from "../../stores/settings.store.js";
import type { FeedbackImage } from "./feedback.js";
import { useFeedbackStore } from "./feedback.store.js";

interface ScreenshotCapturedDetail {
  dataUrl?: string | undefined;
}

export function useScreenshotFeedbackPrompt(): void {
  const enabled = useSettingsStore((s) => s.mobileScreenshotFeedback);
  useEffect(() => {
    if (detectPlatform() !== "capacitor" || !enabled) return;
    const onScreenshot = (event: Event) => {
      if (!useSettingsStore.getState().mobileScreenshotFeedback) return;
      const detail = (event as CustomEvent<ScreenshotCapturedDetail>).detail;
      const image: FeedbackImage | undefined = detail?.dataUrl
        ? { dataUrl: detail.dataUrl, name: "reminders-android-screenshot.png", mime: "image/png" }
        : undefined;
      useFeedbackStore.getState().openFeedback({
        image,
        source: "android-screenshot",
        note: "I just took a screenshot because:",
      });
    };
    window.addEventListener("reminders:screenshot-captured", onScreenshot);
    return () => window.removeEventListener("reminders:screenshot-captured", onScreenshot);
  }, [enabled]);
}
